export const DASHBOARD_NAMES = {
    TRANSACTIONS: 'transactions',
    ACCOUNTS: 'accounts',
    DAILY_BALANCES: 'dailyBalances',
    CUSTOMER_ACCOUNTS: 'clientAccounts',
    SIRCUPA: 'sircupa',
    INFESTADISTICA: 'statistics',
    IDC_EXEMPT: 'afipExempt',
    AFIP: 'afip',
    METRICS: 'metrics',
    INVESTMENTS: 'investmentListing',
    EARNINGS_SETTLEMENT: 'incomeTaxSettlementStatement',
};
